import { useRef, useState } from 'react';

import { Edit02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const EditableBillingEntityName = ({ value, onChange }) => {
  const { t } = useTranslation();
  const defaultName = t('company.tabs.billing.structure.defaultEntityLabel');
  const [editing, setEditing] = useState(false);
  const valueBeforeEdit = useRef(value);
  const shown = (value || '').trim() || defaultName;

  const start = () => {
    valueBeforeEdit.current = value;
    setEditing(true);
  };

  const finish = () => {
    setEditing(false);
    if ((value || '').trim() === '') onChange(defaultName);
  };

  if (editing) {
    return (
      <input
        autoFocus
        aria-label={t('company.tabs.billing.entities.columnLabel')}
        className="h-[3.2rem] w-full max-w-[20rem] rounded-lg border border-primary-5 bg-white px-3 text-xl font-medium normal-case tracking-normal text-text-primary outline-none"
        value={value}
        onChange={event => onChange(event.target.value)}
        onBlur={finish}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            finish();
          }
          if (event.key === 'Escape') {
            onChange(valueBeforeEdit.current);
            setEditing(false);
          }
        }}
      />
    );
  }

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      overlay={<Tooltip>{t('company.tabs.billing.entities.renameColumn')}</Tooltip>}>
      <button
        type="button"
        onClick={start}
        className="inline-flex items-center gap-2 border-0 bg-transparent p-0 font-medium uppercase tracking-wide text-text-secondary transition-colors hover:text-primary-5">
        <span className="border-b border-dashed border-current">{shown}</span>
        <HugeiconsIcon icon={Edit02Icon} size={13} strokeWidth={2} />
      </button>
    </OverlayTrigger>
  );
};
